import { EditOutlined, UserOutlined, ClearOutlined } from "@ant-design/icons";
import { Button, DatePicker, Input, notification, Select, Spin } from "antd";
import { FieldDisplayDumb } from "../FieldDisplayDumb";
import {
  CourseCategoryMasterType,
  CourseStreamType,
  RequirementsDataDetailsPanelProps,
  StudentPersonalDetailsType,
  StudyLevelMasterType,
  TimingAndScheduleStateType,
} from "./types";
import EditTimeAndSchedule from "./requirements-tutors/EditTimeAndSchedulePopup";
import axiosInstance from "../../axios";
import { useEffect, useState } from "react";
import { omit } from "lodash";
import { timeFromString, toTimeStringDisplay } from "../constants";
import { ActionForNotification, NotificationType, popupTitleAndMessage } from "../utils/notificationPopup";
import dayjs from "dayjs";
import { dateDisplayable, dateTimeDisplayable } from "../table-utils";
// import {
//   courseCategoryState,
//   courseStudyLevelState,
// } from "../../states/courseMaster";
import { useAtom } from "jotai";
import { adminEditDealState, userRole } from "../../states/userRole";
import { USER_ROLES } from "../../constants/roleConstants";
import { studyLevelState } from "../../states/student";

export function RequirementsDataDetailsPanel(props: RequirementsDataDetailsPanelProps) {
  const [spinning, setSpinning] = useState(false);
  const { studentDetails, citys, setStudentDetails, tentativeDate, setTentativeDate, studentDealStatus } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [courseCategory, _setCourseCategory] =
  //   useAtom<CourseCategoryMasterType[]>(courseCategoryState);
  const [courseCategory, setCourseCategory] = useState<CourseCategoryMasterType[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [studyLevel, _setStudyLevel] = useAtom<StudyLevelMasterType[]>(studyLevelState);
  // const [studyLevel, setStudyLevel] = useState<StudyLevelMasterType[]>([]);
  const [courseStream, setCourseStream] = useState<CourseStreamType[]>([]);
  const [canShowLevel, setCanShowLevel] = useState<boolean>(true);
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState<Partial<StudentPersonalDetailsType> | null>(studentDetails);
  const [selectedStream, setSelectedStream] = useState<number | null>(studentDetails.stream_id);
  const [tutionTimingAndState, setTimingAndScheduleState] = useState<TimingAndScheduleStateType | undefined>(undefined);
  const [NotificationInstanceApi, NotificationInstanceContextHolder] = notification.useNotification();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [role, _setRole] = useAtom<string>(userRole);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [canAdminEditDeal, _setCanAdminEditDeal] = useAtom(adminEditDealState);

  useEffect(() => {
    fetchTimingAndSchedule();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    fetchCourseCategoryMaster();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    fetchStudyLevelMaster();
  }, []);
  useEffect(() => {
    fetchCourseStreamMaster();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue?.category_id]);

  const openNotificationWithIcon = (
    type: NotificationType,
    action: keyof typeof ActionForNotification,
    description?: string,
  ) => {
    NotificationInstanceApi[type]({
      message: popupTitleAndMessage[action][type].title,
      description: description ?? popupTitleAndMessage[action][type].description,
      placement: "bottomRight",
    });
  };

  async function updateStudentDealRequirement() {
    try {
      const { data } = await axiosInstance.post("/v1/cre/student/deal/requirement", {
        ...inputValue,
        gmap_meta_data: inputValue?.gmap_meta_data ? JSON.parse(inputValue.gmap_meta_data) : [],
        dealings_id: studentDetails.id,
        class_level_id: canShowLevel ? inputValue?.level : null,
        subject: inputValue?.requirements ?? "",
      });
      if (data.success && data?.data) {
        setStudentDetails(data?.data);
        setTentativeDate(data?.data?.tentative_date);
        openNotificationWithIcon("success", "STORE_STUDENT_DEAL_REQUIREMENT");
      } else {
        openNotificationWithIcon("error", "STORE_STUDENT_DEAL_REQUIREMENT", data.message);
      }
    } catch (error) {
      setInputValue(studentDetails);
      openNotificationWithIcon("error", "STORE_STUDENT_DEAL_REQUIREMENT");
    }
    setSpinning(false);
  }

  async function fetchCourseCategoryMaster() {
    try {
      const { data } = await axiosInstance.get("/v1/cre/master/course-category/all");
      if (data && data.length) {
        setCourseCategory(data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchStudyLevelMaster() {
    // try {
    //   const { data } = await axiosInstance.get(
    //     "/v1/cre/master/study-level/all"
    //   );
    //   if (data && data.length) {
    //     setStudyLevel(data);
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  }

  async function fetchCourseStreamMaster() {
    try {
      console.log("calling for:", inputValue?.category_id);
      if (!inputValue?.category_id) return;
      const { data }: { data: CourseStreamType[] } = await axiosInstance.get("/v1/cre/student/stream/courses/all", {
        params: {
          category_id: inputValue?.category_id,
        },
      });
      if (data && data.length) {
        setCourseStream(data);
      }
      console.log("streammmmm", data);
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchTimingAndSchedule() {
    try {
      const { data } = await axiosInstance.get(`/v1/cre/student/timing-schedule`, {
        params: {
          dealings_id: studentDetails.id,
        },
      });

      const timingState = omit(data?.data, ["id"]);
      setTimingAndScheduleState({
        ...timingState,
        ...{
          tuition_start_time: timeFromString(timingState.tuition_start_time),
        },
        ...{ tuition_end_time: timeFromString(timingState.tuition_end_time) },
      } as TimingAndScheduleStateType);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      <Spin spinning={spinning} fullscreen />
      <div className="tail-p-4 tail-border tail-rounded-md tail-border-zinc-300">
        {NotificationInstanceContextHolder}
        <div className="tail-flex tail-justify-between">
          <div className=" tail-text-blue-500">
            <UserOutlined className="tail-text-2xl"></UserOutlined>
            <span className="tail-text-lg tail-font-medium">Requirements</span>
          </div>
          <div className="tail-flex tail-items-center tail-gap-2">
            <Button
              // disabled={!canAdminEditDeal}
              type="primary"
              className="tail-mt-2"
              icon={<EditOutlined />}
              iconPosition="end"
              size="middle"
              onClick={() => {
                setCanShowLevel(
                  courseCategory.find((category) => category.category_id === inputValue?.category_id)?.showLevel ??
                    false,
                );
                if (isEditing) {
                  setSpinning(true);
                  updateStudentDealRequirement();
                }
                setIsEditing(!isEditing);
              }}
            >
              {isEditing ? "Save" : "Edit"}
            </Button>
            {isEditing && (
              <Button
                danger
                className="tail-mt-2"
                icon={<ClearOutlined />}
                iconPosition="end"
                size="middle"
                onClick={() => {
                  setIsEditing(!isEditing);
                }}
              >
                Clear
              </Button>
            )}
          </div>
        </div>
        <div className="tail-flex tail-items-end tail-py-3">
          {/* add commented code here */}

          <div className="tail-flex tail-grow tail-flex-col tail-max-w-[60%] tail-gap-y-2">
            {isEditing ? (
              <>
                <div key="course_category" className="tail-flex tail-items-center tail-gap-4 tail-mb-2">
                  <label className="tail-w-40 tail-font-medium">Course Category:</label>
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Select"
                    defaultValue={
                      courseCategory.find((category) => category.category_id === inputValue?.category_id)?.category_name
                    }
                    onChange={(value) => {
                      setInputValue({
                        ...inputValue,
                        category_id: Number(value),
                      });
                      setSelectedStream(null);
                      setCanShowLevel(
                        courseCategory.find((category) => category.category_id === Number(value))?.showLevel ?? false,
                      );
                    }}
                    options={courseCategory?.map((category) => ({
                      key: category.category_id,
                      label: category.category_name,
                      value: category.category_id,
                    }))}
                  />
                </div>
                <div
                  key="study_level"
                  className="tail-flex tail-items-center tail-gap-4 tail-mb-2"
                  style={{ display: canShowLevel ? "" : "none" }}
                >
                  <label className="tail-w-40 tail-font-medium">Level:</label>
                  <Select
                    allowClear
                    style={{
                      width: "100%",
                      display: canShowLevel ? "" : "none",
                    }}
                    placeholder="Select"
                    defaultValue={inputValue?.level}
                    onChange={(value) => {
                      setInputValue({
                        ...inputValue,
                        level: Number(value),
                      });
                    }}
                    options={studyLevel.map((level) => ({
                      value: level.id,
                      label: level.name,
                    }))}
                  />
                </div>
                <div key="course_stream" className="tail-flex tail-items-center tail-gap-4 tail-mb-2">
                  <label className="tail-w-40 tail-font-medium">Course Stream:</label>
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Select"
                    defaultValue={selectedStream}
                    onChange={(value: number) => {
                      setInputValue({
                        ...inputValue,
                        stream_id: Number(value),
                      });
                      setSelectedStream(value);
                    }}
                    options={courseStream.map((stream: any) => ({
                      key: stream.stream_id,
                      value: stream.stream_id,
                      label: stream.stream_name,
                    }))}
                  />
                </div>
                <div key="subject" className="tail-flex tail-items-center tail-gap-4 tail-mb-2">
                  <label className="tail-w-40 tail-font-medium">Subject:</label>
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Select"
                    defaultValue={studentDetails?.requirements?.split(",")}
                    onChange={(value: string[]) => {
                      setInputValue({
                        ...inputValue,
                        requirements: value.join(","),
                      });
                    }}
                    options={courseStream
                      .find((stream: any) => stream.stream_id === selectedStream)
                      ?.courses.map((course) => ({ value: course }))}
                  />
                </div>
                <div key="gender_preference" className="tail-flex tail-items-center tail-gap-4 tail-mb-2">
                  <label className="tail-w-40 tail-font-medium">Gender Preference:</label>
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Select"
                    defaultValue={inputValue?.tutor_gender_preference}
                    onChange={(value: string) => {
                      setInputValue({
                        ...inputValue,
                        tutor_gender_preference: value,
                      });
                    }}
                    options={["male", "female", "both"].map((gender) => ({
                      value: gender,
                      label: gender,
                    }))}
                  />
                </div>
                {[USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN].includes(role) &&
                !["NEW", "NOT_INTERESTED"].includes(studentDealStatus) ? (
                  <div key="tentative_date" className="tail-flex tail-items-center tail-gap-4 tail-mb-2">
                    <label className="tail-w-40 tail-font-medium">Tentative Closure Date:</label>
                    <DatePicker
                      showTime
                      defaultValue={tentativeDate ? dayjs(tentativeDate) : null}
                      onChange={(value, _dateString) => {
                        setInputValue({
                          ...inputValue,
                          tentative_date: value.toISOString(),
                        });
                      }}
                      className="tail-w-full"
                    />
                  </div>
                ) : (
                  <></>
                )}
                <div key="tuition_type" className="tail-flex tail-items-center tail-gap-4 tail-mb-2">
                  <label className="tail-w-40 tail-font-medium">Tuition Type:</label>
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Select"
                    defaultValue={inputValue?.tution_type}
                    onChange={(value: string) => {
                      setInputValue({
                        ...inputValue,
                        tution_type: value,
                      });
                    }}
                    options={["online", "offline", "any"].map((type) => ({
                      value: type,
                      label: type,
                    }))}
                  />
                </div>
                <div key="fee_discuss" className="tail-flex tail-items-center tail-gap-4 tail-mb-2">
                  <label className="tail-w-40 tail-font-medium">Fee Discuss:</label>
                  <Input
                    value={inputValue?.fee_discuss}
                    addonBefore="₹"
                    onChange={(e) => {
                      setInputValue({
                        ...inputValue,
                        fee_discuss: e.target.value,
                      });
                    }}
                  />
                </div>
                <div key="fee_percent" className="tail-flex tail-items-center tail-gap-4 tail-mb-2">
                  <label className="tail-w-40 tail-font-medium">Fee Percentage:</label>
                  <Input
                    value={inputValue?.fee_percent}
                    addonAfter="%"
                    onChange={(e) => {
                      setInputValue({
                        ...inputValue,
                        fee_percent: e.target.value,
                      });
                    }}
                  />
                </div>
                <div key="requirement_notes" className="tail-flex tail-items-center tail-gap-4 tail-mb-2">
                  <label className="tail-w-40 tail-font-medium">Req. notes:</label>
                  <Input
                    value={inputValue?.requirement_notes}
                    onChange={(e) => {
                      setInputValue({
                        ...inputValue,
                        requirement_notes: e.target.value,
                      });
                    }}
                  />
                </div>
              </>
            ) : (
              [
                {
                  label: "Name",
                  key: "name",
                  value: `${studentDetails?.first_name} ${studentDetails?.last_name}`,
                },
                {
                  label: "Subjects",
                  key: "requirements",
                  value: studentDetails?.requirements,
                },
                { label: "Level", key: "level", value: studentDetails?.level_name },
                {
                  label: "Course Stream",
                  key: "course_stream",
                  value: courseStream?.find((stream) => stream.stream_id === studentDetails?.stream_id)?.stream_name,
                },
                {
                  label: "City",
                  key: "city_id",
                  value: citys[studentDetails?.city_id],
                },
                {
                  label: "Gender Preference",
                  key: "tutor_gender_preference",
                  value: studentDetails?.tutor_gender_preference,
                },
                {
                  label: "Created",
                  key: "created_at",
                  value: dateDisplayable(studentDetails?.created_at),
                },
                {
                  label: "Tentative Closure Date",
                  key: "tentative_closure_date",
                  value: dateTimeDisplayable(tentativeDate),
                }, //tentative_closure_date
                {
                  label: "Tuition Type",
                  key: "tution_type",
                  value: studentDetails?.tution_type,
                }, // online, offline, any
                {
                  label: "Fee Discuss",
                  key: "fee_discuss",
                  value: studentDetails?.fee_discuss,
                },
                {
                  label: "Fee Percentage",
                  key: "fee_percent",
                  value: studentDetails?.fee_percent,
                },
                {
                  label: "Req. notes",
                  key: "requirement_notes",
                  value: studentDetails?.requirement_notes,
                },
              ].map(({ label, key, value }) => (
                <div key={key} className="tail-flex tail-items-center tail-gap-4">
                  <span className="tail-w-40 tail-font-medium">{label}:</span>
                  <span className="tail-flex-1">{value}</span>
                </div>
              ))
            )}
          </div>

          <div className="tail-flex-col tail-flex tail-gap-y-2 tail-grow tail-items-end">
            <p className="tail-text-blue-500 tail-font-bold"> Timing and Schedule :</p>
            <FieldDisplayDumb
              head="No of Classes/Week"
              val={(tutionTimingAndState?.how_many_days_in_a_week || "").toString()}
            ></FieldDisplayDumb>
            <FieldDisplayDumb
              head="Tuition timing between"
              val={`${toTimeStringDisplay(tutionTimingAndState?.tuition_start_time!)} to ${toTimeStringDisplay(
                tutionTimingAndState?.tuition_end_time!,
              )}`}
            ></FieldDisplayDumb>
            <FieldDisplayDumb
              head="No of Teaching hours"
              val={`${(tutionTimingAndState?.tuition_hours as string) || studentDetails?.tuition_hours} hrs/day`}
            ></FieldDisplayDumb>
            <FieldDisplayDumb head="Internal Notes" val={`${(tutionTimingAndState?.note as string) ?? ""}`}></FieldDisplayDumb>
            <EditTimeAndSchedule
              tutionTimingAndState={tutionTimingAndState}
              setTimingAndScheduleState={setTimingAndScheduleState}
              data={studentDetails}
              afterClose={fetchTimingAndSchedule}
            />
            {/* <Button type="link" icon={<EditOutlined />} size="small" iconPosition="end">Edit</Button> */}
          </div>
        </div>
      </div>
    </>
  );
}
